import React, {useState, useEffect} from 'react';
import FolderIcon from '@mui/icons-material/Folder';
import {Ladder, SCBA, Helmet, Boot, SteeringWheel, Pants} from '-/components/Icons';

const customIcons = {Ladder, SCBA, Helmet, Boot, SteeringWheel, Pants};
const iconCache = {};

// Lazy-load a curated icon barrel (Filled variants + production-used variants;
// see bin/build-curated-icons.js). Importing the @mui/icons-material root
// barrel ships every icon × every variant (~3.7 MB / 638 KB gzip).
let iconsModulePromise = null;
function getIconsModule() {
    if (!iconsModulePromise) {
        iconsModulePromise = import('-/data/icons/curatedIcons.js').then(m => m.default);
    }
    return iconsModulePromise;
}

function loadIcon(name) {
    return getIconsModule().then(icons => icons[name]);
}

export default function DynamicIcon({name, fallback: Fallback = FolderIcon, ...props}) {
    const [IconComponent, setIconComponent] = useState(() => {
        if (name && customIcons[name]) return customIcons[name];
        if (name && iconCache[name]) return iconCache[name];
        return null;
    });

    useEffect(() => {
        if (!name || IconComponent) return;

        loadIcon(name).then(Icon => {
            if (Icon) {
                iconCache[name] = Icon;
                setIconComponent(() => Icon);
            }
        }).catch(() => {
            // Icon name not found
        });
    }, [name]); // eslint-disable-line

    if (!IconComponent) return Fallback ? <Fallback {...props} /> : null;
    return <IconComponent {...props} />;
}

// Lazy-load the full icon list only when needed (for icon picker dialogs)
let iconNamesCache = null;
export function getIconNames() {
    if (iconNamesCache) return iconNamesCache;
    iconNamesCache = import(
        /* webpackChunkName: "mui-icon-names" */
        '-/data/muiIconNames.json'
    ).then(mod => mod.default);
    return iconNamesCache;
}
